require("../sass/style.scss");
require("../fonts/fontello/css/fontello.css");
import "swiper/css/bundle"; //swiper styles
import 'plyr/dist/plyr.css'; //plyr styles

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/bootstrap-tab");
require("./vendor/fslightbox");
require("./custom/header.es6");

(function ($) {

    if ($(".button-elastic-animation").length > 0) {
        require("./custom/buttons-animations.es6");
    }
    if ($(".button-snail-eyes-animation").length > 0) {
        require("./custom/buttons-animation-1.es6");
    }
    // if ($("body.home").length > 0) {
    //     require("./custom/modals-home-page.es6");
    // }
    if ($(".single-product").length > 0) {
        require("./custom/product.es6");
    }
    if ($(".single-faqs__wrapper").length > 0) {
        require("./page_builder/section_faq_product.es6");
    }
    if ($(".section-scrollTrigger").length > 0) {
        require("./custom/general-scroll-trigger.es6");
    }

    if ($(".section-home-top-banner").length > 0) {
        require("./page_builder/section_home_top_banner.es6");
    }

    if ($(".products-custom").length > 0) {
        require("./custom/product-category.es6");
    }

    if ($(".section-features-banner").length > 0) {
        require("./page_builder/section_features_banner.es6");
    }

    if ($(".section-faq").length > 0) {
        require("./page_builder/section_faq.es6");
    }

    if ($(".section-mixed-boxes").length > 0) {
        require("./page_builder/section_mixed_boxes.es6");
    }

    if ($(".other-products__slider").length > 0) {
        require("./page_builder/section_other_products.es6");
    }

    if ($(".section-testimonials").length > 0 && !$(".simple-reviews").length > 0) {
        require("./page_builder/section_testimonials.es6");
        require("./vendor/modal.js");
    }

    if ($(".section-with-articles").length > 0) {
        require("./page_builder/section_slider_with_articles.es6");
    }

    if ($(".section-slider-with-blocks").length > 0) {
        require("./page_builder/section_slider_with_blocks_type_1.es6");
    }

    if ($(".section-slider-with-products").length > 0) {
        require("./page_builder/section_slider_with_products.es6");
    }

    if ($(".section-continuous-slider").length > 0) {
        require("./vendor/jquery.marquee.min.js");
        require("./page_builder/section_continuous_sliders.es6");
    }

    if ($(".section-cooking-process").length > 0) {
        require("./page_builder/section_cooking_process.es6");
        require("./vendor/modal.js");
    }

    if ($(".section-video-with-popup").length > 0) {
        require("./page_builder/section_video_with_popup.es6");
        require("./vendor/modal.js");
    }

    if ($(".section-video-with-popup-blog").length > 0) {
        require("./page_builder/section_video_with_popup_blog.es6");
        require("./vendor/modal.js");
    }

    if ($(".section-grid-images-with-popups-blog").length > 0) {
        require("./page_builder/section_grid_images_with_popups_blog.es6");
        require("./vendor/modal.js");
    }

    if ($(".section-blog-overview").length > 0) {
        require("./page_builder/section_blog_overview.es6");
    }
    if ($(".contact-blocks").length > 0) {
        require("./page_builder/section_contact_blocks.es6");
    }
    if ($(".contact-main").length > 0) {
        require("./page_builder/section_contact_main.es6");
    }
    if ($(".simple-reviews").length > 0) {
        require("./page_builder/section_simple_reviews.es6");
        require("./vendor/modal.js");
    }
    if ($(".single-blog").length > 0) {
        require("./custom/single-blog.es6");
    }
    if ($(".store-locator").length > 0) {
        require("./custom/store-locator.es6");
    }
    if ($(".contact-stores").length > 0) {
        require("./page_builder/section_contact_store.es6");
    } 
    if ($(".section-simple-content").length > 0) {
        require("./custom/privacy.es6");
    }

    if ($(".section-simple-content-with-sidebar").length > 0) {
        require("./custom/privacy.es6");
        require("./page_builder/section_simple_content_with_sidebar.es6");
    }

    if ($(".links-slider").length > 0) {
        require("./page_builder/section_category_slider.es6");
    }

})(jQuery);